import { render, staticRenderFns } from "./StudentRegistration.vue?vue&type=template&id=1a0c6106&scoped=true&lang=pug"
import script from "./StudentRegistration.vue?vue&type=script&lang=js"
export * from "./StudentRegistration.vue?vue&type=script&lang=js"
import style0 from "./StudentRegistration.vue?vue&type=style&index=0&id=1a0c6106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0c6106",
  null
  
)

export default component.exports